"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SenderCard", {
  enumerable: true,
  get: function get() {
    return _SenderCard["default"];
  }
});
Object.defineProperty(exports, "CardAction", {
  enumerable: true,
  get: function get() {
    return _SenderCard.CardAction;
  }
});
Object.defineProperty(exports, "SenderList", {
  enumerable: true,
  get: function get() {
    return _SenderList["default"];
  }
});
Object.defineProperty(exports, "BlockPrompt", {
  enumerable: true,
  get: function get() {
    return _Prompt["default"];
  }
});
exports["default"] = exports.APPROVE_SENDER_HEIGHT = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _SenderCard = _interopRequireWildcard(require("./SenderCard"));

var _SenderList = _interopRequireDefault(require("./SenderList"));

var _Prompt = _interopRequireDefault(require("./Prompt"));

var APPROVE_SENDER_HEIGHT = 160;
exports.APPROVE_SENDER_HEIGHT = APPROVE_SENDER_HEIGHT;

var _default = function _default(_ref) {
  var children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    className: "mx-4 bg-none",
    style: {
      height: APPROVE_SENDER_HEIGHT
    }
  }), children);
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map